import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  company: {},
  errors: {},
  requesting: null,
  submitting: null,
  isSaved: false,
};

const Slice = createSlice({
  name: '@admin/Companies|Form',
  initialState,
  reducers: {
    
    /**
     * RESET
     */
    initialState: (state) => {
      state.requesting = null;
      state.submitting = null;
      state.errors = {};
      state.company = {};
      state.isSaved = false;
    },

    /**
     * GET COMPANY
     */
    getCompany: (state) => {
      state.requesting = true;
      state.company = {};
    },
    getCompanySuccess: (state, action) => {
      const { payload } = action;
      state.company = payload;
      state.requesting = false;
    },
    getCompanyFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    /**
     * SAVE FORM
     */
    saveForm: (state) => {
      state.submitting = true;
      state.isSaved = false;
      state.errors = {};
    },
    saveFormSuccess: (state, action) => {
      const { payload } = action;
      state.company = payload;
      state.submitting = false;
      state.isSaved = true;
    },
    saveFormFailed: (state, action) => {
      state.errors = action.payload;
      state.submitting = false;
      state.isSaved = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminCompaniesFormReducers: Slice.reducer,
}
export default Reducers;

